// Марки платёжных систем.
//
// ВРЕМЕННЫЕ: начертания упрощены и не соответствуют официальным гайдлайнам
// Apple и Google, у обеих компаний свои требования к воспроизведению знака.
// Заменить на официальные ресурсы до продакшена. Вынесены в отдельный файл
// ровно ради того, чтобы замена была одним движением.

export const ApplePayMark = ({ className = "h-4 w-auto" }) => (
  <svg className={className} viewBox="0 0 46 16" aria-label="Apple Pay" role="img">
    <path
      d="M8.4 3.1c.5-.6.8-1.4.7-2.2-.7 0-1.5.5-2 1.1-.4.5-.8 1.3-.7 2.1.8.06 1.5-.4 2-1zM9.1 4.3c-1.1-.06-2.1.6-2.6.6-.5 0-1.4-.6-2.3-.6-1.2 0-2.3.7-2.9 1.8-1.2 2.1-.3 5.3.9 7 .6.9 1.3 1.8 2.2 1.8.9-.04 1.2-.6 2.2-.6 1 0 1.3.6 2.2.6.9-.02 1.5-.9 2.1-1.7.7-1 .9-1.9.9-2-.02-.01-1.8-.7-1.8-2.8 0-1.8 1.4-2.6 1.5-2.7-.8-1.2-2.1-1.4-2.5-1.4z"
      fill="currentColor"
    />
    <text x="14" y="13" fontFamily="Inter, sans-serif" fontSize="12.5" fontWeight="500" fill="currentColor">Pay</text>
  </svg>
);

export const GooglePayMark = ({ className = "h-4 w-auto" }) => (
  <svg className={className} viewBox="0 0 52 16" aria-label="Google Pay" role="img">
    <path
      d="M8.8 7.3v2h4.7c-.14.9-.5 1.6-1.05 2.1-.66.66-1.7 1.4-3.65 1.4-2.9 0-5.2-2.35-5.2-5.25S5.9 2.3 8.8 2.3c1.57 0 2.7.6 3.55 1.4l1.4-1.4C12.6 1.2 11.1.3 8.8.3 4.8.3 1.5 3.5 1.5 7.55S4.8 14.8 8.8 14.8c2.15 0 3.78-.7 5.05-2.03 1.3-1.3 1.7-3.14 1.7-4.62 0-.46-.03-.88-.1-1.23z"
      fill="currentColor"
    />
    <text x="18" y="13" fontFamily="Inter, sans-serif" fontSize="12.5" fontWeight="500" fill="currentColor">Pay</text>
  </svg>
);

// Один знак по устройству. Определяем платформу заранее и передаём сюда,
// а не гадаем внутри: то же значение нужно и тексту кнопки, и ссылке.
export const PayMark = ({ android, className }) =>
  android ? <GooglePayMark className={className} /> : <ApplePayMark className={className} />;
